import {
	Data,
	LayoutDataItems,
	ResolvedRefArray,
	Style,
	UnresolvedRefArray,
	UnresolvedVariantRelation,
} from '@wix/thunderbolt-becky-types'
import { removeHash } from './utils'

export const getOverridesRefArrayId = (refArrayId: string) => `${refArrayId}-refArrayOverride`

export type StyleOrLayoutMap = Data['theme_data' | 'layout_data']
export type StyleOrLayoutItem = Style | LayoutDataItems

export const inflateResolvedRefArray = (resolvedRefArray: ResolvedRefArray<StyleOrLayoutItem>, dataQuery: string) => ({
	...resolvedRefArray,
	id: dataQuery,
	values: resolvedRefArray.values.map((value) => {
		if (value.type === 'VariantRelation') {
			const to = value.to
			const inflatedVariantRelationId = `${dataQuery}-${value.id}`
			const inflatedItemId = `${dataQuery}-${to.id}`
			return {
				...value,
				id: inflatedVariantRelationId,
				to: {
					...to,
					id: inflatedItemId,
				},
			}
		}
		const inflatedItemId = `${dataQuery}-${value.id}`
		return {
			...value,
			id: inflatedItemId,
		}
	}),
})

export const getDataOverrides = (resolvedRefArray: ResolvedRefArray<StyleOrLayoutItem>, dataQuery: string) => {
	const dataOverrides: Record<string, UnresolvedRefArray | UnresolvedVariantRelation | StyleOrLayoutItem> = {}
	dataOverrides[dataQuery] = {
		...resolvedRefArray,
		id: dataQuery,
		values: resolvedRefArray.values.map((value) => `#${value.id}`),
	}

	resolvedRefArray.values.forEach((value) => {
		if (value.type === 'VariantRelation') {
			dataOverrides[value.id] = { ...value, to: `#${value.to.id}` }
			dataOverrides[value.to.id] = value.to
		} else {
			dataOverrides[value.id] = value
		}
	})
	return dataOverrides
}

export const resolveRefArray = (refArray: UnresolvedRefArray, dataMap: StyleOrLayoutMap) =>
	({
		...refArray,
		values: refArray.values.map((itemId) => {
			const resolvedItem = dataMap[removeHash(itemId)]
			if (resolvedItem.type !== 'VariantRelation') {
				return resolvedItem
			}
			const to = dataMap[removeHash((resolvedItem as UnresolvedVariantRelation).to)]
			return {
				...resolvedItem,
				to,
			}
		}),
	} as ResolvedRefArray<StyleOrLayoutItem>)

export const inflateWithoutPresets = (
	resolvedRefArray: ResolvedRefArray<StyleOrLayoutItem>,
	dataQuery: string,
	mergedDataMap: StyleOrLayoutMap = {}
) => {
	const inflatedAndResolvedRefArray = inflateResolvedRefArray(resolvedRefArray, dataQuery)

	const overridesRefArrayId = getOverridesRefArrayId(dataQuery)
	const overridesRefArray = mergedDataMap[overridesRefArrayId] as UnresolvedRefArray
	if (overridesRefArray) {
		const resolvedOverridesRefArray = resolveRefArray(overridesRefArray, mergedDataMap)
		const inflatedAndResolvedOverridesRefArray = inflateResolvedRefArray(resolvedOverridesRefArray, dataQuery)

		inflatedAndResolvedRefArray.values = inflatedAndResolvedRefArray.values.concat(
			inflatedAndResolvedOverridesRefArray.values
		)
	}

	return getDataOverrides(inflatedAndResolvedRefArray, dataQuery)
}
